// ==============================|| OVERRIDES - BUTTON ||============================== //

export default function Button(theme) {
  return {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          fontWeight: 500,
          padding: "10px 20px",
          borderRadius: 0,
          // whiteSpace: "nowrap",
        },
        contained: {
          color: "white",
        },
        sizeSmall: {
          padding: "5px 12px",
        },
      },
    },
  };
}
